import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

const lineV = {
  hidden: { y: "105%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease: EASE, delay: 0.08 * i } }),
};

// Masked line-by-line heading reveal. `lines` is an array of nodes.
export const MaskHeading = ({ lines, as = "h2", className = "", onLoad = false, baseDelay = 0, testId }) => {
  const M = motion[as];
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <M className={className} {...trigger} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className="block" variants={lineV} custom={i + baseDelay * 10}>
            {line}
          </motion.span>
        </span>
      ))}
    </M>
  );
};

export const EASE_OUT = EASE;
